module.exports = __webpack_public_path__ + "img/img3.c68b619e.png";